<template>
    <div>
        <b-row v-if="formData">
            <b-col cols="12" md="6">
                <b-form-group :label="$t('coop_cv_name')">
                    <div class="label-as-input">{{ formData.name || '-' }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('coop_cv_file')">
                    <div class="label-as-input">
                        <a href="#" @click.prevent="downloadFile" class="text-primary">
                            <i class="ri-download-line"></i> {{ formData.fileName || '-' }}
                        </a>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('label')">
                    <div class="label-as-input">
                        <b-badge v-for="tag in tagLabels" :key="tag" variant="secondary" class="mr-1">
                            {{ tag }}
                        </b-badge>
                        <span v-if="!tagLabels.length">-</span>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import CoopCvService from '@/services/CoopCvService';

    export default {
        props: {
            formId: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                formData: null,
                tagOptions: [
                    { value: 'tr', text: 'Türkçe' },
                    { value: 'en', text: 'İngilizce' },
                    { value: 'de', text: 'Almanca' },
                    { value: 'fr', text: 'Fransızca' }
                ]
            };
        },
        computed: {
            tagLabels() {
                if (!this.formData || !this.formData.tags || !this.formData.tags.length) return [];
                return this.formData.tags.map(val => {
                    const found = this.tagOptions.find(o => o.value === val);
                    return found ? found.text : val;
                });
            }
        },
        created() {
            this.getCV();
        },
        methods: {
            getCV() {
                CoopCvService.get(this.formId).then(response => {
                    this.formData = response.data.data;
                });
            },
            downloadFile() {
                this.$toast.info(this.$t('downloading') || 'Dosya indiriliyor...');
                // Mock indirme simülasyonu
                setTimeout(() => {
                    this.$toast.success(this.$t('downloaded') || 'Dosya indirildi.');
                }, 1000);
            }
        }
    };
</script>

<style scoped>
    .label-as-input {
        background-color: #f8f9fa;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        padding: 0.375rem 0.75rem;
        min-height: 38px;
        display: flex;
        align-items: center;
    }
</style>
